import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { LOGGED } from "util/constants";
import { useTranslation } from "react-i18next";
import "../chartsStyle.scss";
import KpiViewBoard from "./KpiViewBoard";

function openFullscreen(setFullscreenMode) {
  const root = document.documentElement;
  if (root.requestFullscreen) {
    root.requestFullscreen();
    setFullscreenMode(true);
  } else if (root.webkitRequestFullscreen) {
    root.webkitRequestFullscreen();
    setFullscreenMode(true);
  } else if (root.msRequestFullscreen) {
    root.msRequestFullscreen();
    setFullscreenMode(true);
  }
}

function closeFullscreen(setFullscreenMode) {
  if (document.cancelFullScreen) {
    document.cancelFullScreen();
    setFullscreenMode(false);
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
    setFullscreenMode(false);
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
    setFullscreenMode(false);
  }
}

export default function KpiPresentationView({
  authenticated,
  user,
  reviewsMode = false,
}) {
  const location = useLocation()?.search;
  const params = new URLSearchParams(location);
  const teamId = params.get("id");
  const chartPeriod = params.get("period") || "M";
  const theme = useSelector((state) => state.DashboardReducer.theme);
  const { t, i18n } = useTranslation();
  const [fullscreenMode, setFullscreenMode] = useState(false);
  const [presentationTitle, setPresentationTitle] = useState(() =>
    typeof window !== "undefined" && window.title?.trim()
      ? window.title.trim()
      : t("team_kpi_view.presentation_title", "Global Executive Dashboard")
  );

  useEffect(() => {
    if (typeof window !== "undefined" && window.title?.trim()) {
      setPresentationTitle(window.title.trim());
      return;
    }
    setPresentationTitle(
      t("team_kpi_view.presentation_title", "Global Executive Dashboard")
    );
  }, [i18n.language, t]);

  if (authenticated !== LOGGED) {
    if (typeof window !== "undefined" && window.innerWidth < 1200) {
      window.location = `${window.location.origin}/login`;
    }
    return null;
  }

  if (!teamId) return null;

  const themeClass =
    theme === "light"
      ? "light-theme-executive"
      : theme === "brand"
      ? "brand-theme-executive"
      : "default-theme-executive";

  return (
    <div className={themeClass} style={{ height: "100vh" }}>
      <div className="presentation-mode-title">
        <img src="/assets/pivony-logo.png" alt="" className="logo" />
        <span>
          {theme === "brand" && user?.logo_url ? (
            <img src={user.logo_url} alt="" />
          ) : (
            ""
          )}
          {presentationTitle}
        </span>
        {fullscreenMode ? (
          <img
            src="/assets/minimize-2.svg"
            alt=""
            onClick={() => closeFullscreen(setFullscreenMode)}
          />
        ) : (
          <img
            src="/assets/maximize-2.svg"
            alt=""
            onClick={() => openFullscreen(setFullscreenMode)}
          />
        )}
      </div>
      <div
        className={`kpi-charts-loader-global ${
          reviewsMode ? "presentation-mode-review" : "presentation-mode-container"
        }`}
      >
        <KpiViewBoard
          selectedTeamItem={teamId}
          chartPeriod={chartPeriod}
          readOnly
          presentationMode
          reviewsPresentationMode={reviewsMode}
        />
      </div>
    </div>
  );
}
